export default __webpack_public_path__ + "8d4a6ae0e9edae9afc7b714ca093d571.jpg";